/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Phone_Is_Background_Blurring_AllowedInputs */

const en_forms_users_settings_phone_is_background_blurring_allowed = /** @type {(inputs: Forms_Users_Settings_Phone_Is_Background_Blurring_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allowed`)
};

const de_forms_users_settings_phone_is_background_blurring_allowed = /** @type {(inputs: Forms_Users_Settings_Phone_Is_Background_Blurring_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrundunschärfe erlaubt`)
};

/**
* | output |
* | --- |
* | "Allowed" |
*
* @param {Forms_Users_Settings_Phone_Is_Background_Blurring_AllowedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_phone_is_background_blurring_allowed = /** @type {((inputs?: Forms_Users_Settings_Phone_Is_Background_Blurring_AllowedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Phone_Is_Background_Blurring_AllowedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_phone_is_background_blurring_allowed(inputs)
	return de_forms_users_settings_phone_is_background_blurring_allowed(inputs)
});